module.exports = __webpack_public_path__ + "img/influences.4b3856e.jpg";